import { Component, OnInit } from '@angular/core';
import { AddScoringParametreComponent } from './add-scoring-parametre/add-scoring-parametre.component';
import { EditScoringParametreComponent } from './edit-scoring-parametre/edit-scoring-parametre.component';
import { ScoringParametreService } from '../core/service/scoring-parametre.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ScoringParametrage } from '../core/model/ScoringParametrage';

@Component({
  selector: "app-scoring-parametre",
  templateUrl: "./scoring-parametre.component.html",
  styleUrls: ["./scoring-parametre.component.scss"]
})
export class ScoringParametreComponent implements OnInit {
  scoringParametrage: ScoringParametrage[];

  constructor(
    private modalService: NgbModal,
    private _scoringParametreService: ScoringParametreService
  ) {}

  ngOnInit() {
    this.getScoringParametrage();
  }

  getScoringParametrage() {
    this._scoringParametreService.getAllScoringParametrage().subscribe(
      data => {
        this.scoringParametrage = data;
      },
      error => {
        console.log(error);
      }
    );
  }

  edit(scoringParametrage: ScoringParametrage): void {
    const modalRef = this.modalService.open(EditScoringParametreComponent, {
      centered: true
    });
    modalRef.componentInstance.scoringParametrage = scoringParametrage;

    modalRef.result.then(
      data => {
        // on close
        this.getScoringParametrage();
      },
      reason => {
        // on dismiss
      }
    );
  }

  add(): void {
    const modalRef = this.modalService.open(AddScoringParametreComponent, {
      centered: true
    });

    modalRef.result.then(
      data => {
        // on close
        this.getScoringParametrage();
      },
      reason => {
        // on dismiss
      }
    );
  }
}
